import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import ToolsDirectory from './pages/ToolsDirectory';
import ToolDetail from './pages/ToolDetail';
import AllToolsPage from './pages/AllToolsPage';
import CategoryPage from './pages/CategoryPage';
import ComparisonPage from './pages/ComparisonPage';
import AboutPage from './pages/AboutPage';
import Dashboard from './pages/Dashboard';
import PricingPage from './pages/PricingPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import CryptoCalculatorsHub from './pages/CryptoCalculatorsHub';
import LatestUpdatesPage from './pages/LatestUpdatesPage';
import TopToolsPage from './pages/TopToolsPage';
import HTMLSitemapPage from './pages/HTMLSitemapPage';
import AffiliateAnalyticsPage from './pages/AffiliateAnalyticsPage';
import CryptoTaxCalculatorUSA from './pages/CryptoTaxCalculatorUSA';
import CryptoTaxCalculatorUK from './pages/CryptoTaxCalculatorUK';
import CryptoTaxCalculatorEurope from './pages/CryptoTaxCalculatorEurope';
import BitcoinTaxCalculator from './pages/BitcoinTaxCalculator';
import CryptoProfitTaxCalculator from './pages/CryptoProfitTaxCalculator';
import AuthCallback from './pages/AuthCallback';
import './App.css';

const AppContent = () => {
  const location = useLocation();
  
  // Check for session_id in URL hash for OAuth callback
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/tools" element={<ToolsDirectory />} />
          <Route path="/tools/:slug" element={<ToolDetail />} />
          <Route path="/all-tools" element={<AllToolsPage />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/compare/:slug" element={<ComparisonPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/crypto-calculators" element={<CryptoCalculatorsHub />} />
          <Route path="/latest-updates" element={<LatestUpdatesPage />} />
          <Route path="/top-tools" element={<TopToolsPage />} />
          <Route path="/sitemap" element={<HTMLSitemapPage />} />
          <Route path="/admin/affiliate-analytics" element={<AffiliateAnalyticsPage />} />
          <Route path="/crypto-tax-calculator-usa" element={<CryptoTaxCalculatorUSA />} />
          <Route path="/crypto-tax-calculator-uk" element={<CryptoTaxCalculatorUK />} />
          <Route path="/crypto-tax-calculator-europe" element={<CryptoTaxCalculatorEurope />} />
          <Route path="/bitcoin-tax-calculator" element={<BitcoinTaxCalculator />} />
          <Route path="/crypto-profit-tax-calculator" element={<CryptoProfitTaxCalculator />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
